import React from 'react';
import LightTooltip from 'mui/Tooltip/LightTooltip';
import { formatDate } from 'services/date';

import { useEncounterSegment } from '../../EncounterSegment';

import './CardHeaderMiddleDefault.scss';

export default function CardHeaderMiddleDefault() {
  const { encounter } = useEncounterSegment();
  const { sitePatientEncounter, numberOfRequiredFields } = encounter;

  const { numberOfCompletedRequiredFields, start, completedFromFinancialPoint, end, edcVisitDate } =
    sitePatientEncounter || {};

  const progressInPercent = Math.round((100 / numberOfRequiredFields) * numberOfCompletedRequiredFields);

  return (
    <>
      <div className="est-comments">{sitePatientEncounter?.statusChangeReason}</div>
      <div className="side-group">
        <div className="est-progress">
          {sitePatientEncounter && (
            <>
              <div className="est-progressbar">
                <i style={{ width: `${progressInPercent}%` }} />
              </div>
              <div>
                {numberOfCompletedRequiredFields}/{numberOfRequiredFields}
              </div>
            </>
          )}
        </div>

        <div className="est-finance">{completedFromFinancialPoint && '$'}</div>
        {(start || end) && (
          <LightTooltip
            arrow
            placement="top"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -15]
                    }
                  }
                ]
              }
            }}
            title={
              <div className="overlay-container">
                <span className="content-title">Dates</span>
                <div className="dates-layout">
                  {start && (
                    <div className="date-item">
                      <span className="title">Check-In:</span>
                      <span>{formatDate(start)}</span>
                    </div>
                  )}
                  {end && (
                    <div className="date-item">
                      <span className="title">Completed:</span>
                      <span>{formatDate(end)}</span>
                    </div>
                  )}
                  {edcVisitDate && (
                    <div className="date-item">
                      <span className="title">Visit:</span>
                      <span>{formatDate(edcVisitDate)}</span>
                    </div>
                  )}
                </div>
              </div>
            }
          >
            <div className="est-visit-date">{edcVisitDate && formatDate(edcVisitDate)}</div>
          </LightTooltip>
        )}
      </div>
    </>
  );
}
